module.exports = __webpack_public_path__ + "img/nodata.312dc408.png";